import React, { useEffect, useMemo, useState } from 'react';
import { CARDS } from '../game/cards';
import { sfx } from '../game/sound';

// v2.9: DIVINE DROP OVERLAY — plays when a divine card is rolled into a reward.
// Big golden burst, radial rays, chime, and a card-name reveal. Dismisses automatically
// (also click-through). Non-blocking to gameplay.
export default function DivineDropOverlay({ cardId, onDone }) {
  const [visible, setVisible] = useState(true);
  const card = CARDS[cardId];

  useEffect(() => {
    if (!cardId) return;
    // Kick chime immediately with per-card stinger
    try { sfx.divineChime(cardId); } catch (e) {}
    // v3.0: slow-mo camera zoom — blur+scale the rest of the app while overlay is up
    document.body.classList.add('divine-slowmo');
    const t = setTimeout(() => {
      setVisible(false);
      // small fade window
      setTimeout(() => {
        document.body.classList.remove('divine-slowmo');
        onDone && onDone();
      }, 260);
    }, 2400);
    return () => {
      clearTimeout(t);
      document.body.classList.remove('divine-slowmo');
    };
  }, [cardId, onDone]);

  // 24 radial rays
  const rays = useMemo(() => Array.from({ length: 24 }, (_, i) => i * 15), []);

  if (!cardId || !card) return null;

  const dismiss = () => {
    setVisible(false);
    setTimeout(() => onDone && onDone(), 200);
  };

  return (
    <div
      className={`divine-drop-overlay ${visible ? 'in' : 'out'}`}
      data-testid="divine-drop-overlay"
      data-cardid={cardId}
      onClick={dismiss}
      role="dialog"
      aria-label="Divine card dropped"
    >
      <div className="divine-drop-rays" aria-hidden="true">
        {rays.map(deg => (
          <div key={deg} className="divine-ray" style={{ transform: `rotate(${deg}deg)` }} />
        ))}
      </div>
      <div className="divine-drop-burst" aria-hidden="true" />
      <div className="divine-drop-inner">
        <div className="divine-drop-eyebrow" data-testid="divine-drop-eyebrow">✦ DIVINE ✦</div>
        <div className="divine-drop-art">{card.art}</div>
        <div className="divine-drop-name" data-testid="divine-drop-name">{card.name}</div>
        <div className="divine-drop-desc">{card.desc}</div>
        <div className="divine-drop-hint">click to continue</div>
      </div>
    </div>
  );
}
